//============================
//# mmgenpaydate
//============================
import { ValidationRules } from "@/models/Validation";
import { t } from "@/plugins/i18n";

export default interface PartnerPayDate {
    id: number;
    name: string;
    note: string | null;
    isCustomer: boolean;
    isSupplier: boolean;
    paymentMode: number; //csgenpaymode
    startDate: string | null;
    countType: number; //enum from backend, but table exist at mmgenpayday_type
    dayType: number; //enum from backend
    payTerm: number | null;
    english: string | null;
    foreign: string | null;
    day: number | null;
    skontoDays: number | null;
    skontoPercent: number | null;
    customerAccCode: string | null; //mmbokaccno - accNo
    supplierAccCode: string | null; //mmbokaccno - accNo
    isSkonto: boolean | null;
}

export const PartnerPayDateDefaultProps: PartnerPayDate = {
    id: 0,
    name: "",
    note: null,
    isCustomer: false,
    isSupplier: false,
    paymentMode: 1,
    startDate: null,
    countType: 1,
    dayType: 1,
    payTerm: null,
    english: null,
    foreign: null,
    day: null,
    skontoDays: null,
    skontoPercent: null,
    customerAccCode: null,
    supplierAccCode: null,
    isSkonto: false,
}

export const PartnerPayDateValidationRules: ValidationRules = {
    name: [
        (v: string) => !!v || t("Kotelezo"),
        (v: string) => v.replace(/\s+/g, "").length >= 1 || t("NemLehetRovidebbMintEgyKarakter")
    ],
    skontoDays: [
        (v: number) => (!v || v.valueOf() >= 0) || t("PartnerPayDate_NemLehetNegativErtek")
    ],
    payTerm: [
        (v: number) => (!v || v.valueOf() >= 0) || t("PartnerPayDate_NemLehetNegativErtek")
    ]
};